import React, { useMemo, useCallback } from "react";
import styles from "./mobile-menu.module.scss";
import DownLtLogoBlue from "@svgIcons/DownIt";
import menuItemData from "@/data/menu-items.json";
import Link from "next/link";
import MenuCTA from "./MenuCTA";
import { AssociatedProgramInterface } from ".";
import { GAEvent, GA_EVENTS, GA_EVENTS_PAYLOAD } from "@/helpers/gaEvents";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
const { NAVIGATION_CLICK } = GAEvent;

interface MenuItem {
  enabled: boolean;
  Item: {
    text: string;
    url?: string;
  };
  SubItem?: Array<unknown>;
}

const MenuItemComponent: React.FC<{
  item: MenuItem;
  onClick: () => void;
  closeMenuHandler?: (href:string) => void;
}> = React.memo(({ item, onClick, closeMenuHandler }) => {
  const handleClick = useCallback((item) => {
    onNavigateHandler(item);
    onClick();
  }, [onClick]);

  const onNavigateHandler = (item) => {
      const payload = {
        cta_text: item.Item?.text || "",
        category: item.Item?.title || "",
        sub_category: "NA",
        section_name: "header",
        redirection_url: item.Item?.url || "",
        header_title: "NA",
      };
      const heading = item.Item.text;
  
      setTimeout(() => {
        if (typeof window !== "undefined") {
          const gaData = GA_EVENTS.get(NAVIGATION_CLICK);
          pushToDataLayer({
            ...gaData,
            ...payload,
            page_type: getGlobalStateValue("pageType") || "Home Page",
          });
  
          if (heading == "CAREER SERVICES") {
            window.webengage.track("Career Advice Clicked");
          }else  if (heading == "ADVANTAGES") {
            window.webengage.track("Advantages Clicked");
          }else if (heading == "PROGRAMS") {
            window.webengage.track("Programs Clicked");
          }
        }
      }, 1500);
      if(item.Item.url){
        closeMenuHandler(item.Item.url)
      }
    };

  if (item.Item.url) {
    return (
      <Link
        onClick={() => onNavigateHandler(item)}
        href={item.Item.url}
        className={styles.menuItem}
      >
        {item.Item.text}
        {!!item.SubItem?.length && <DownLtLogoBlue />}
      </Link>
    );
  }

  return (
    <div
      className={styles.menuItem}
      onClick={()=>handleClick(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleClick(item)}
    >
      {item.Item.text}
      {!!item.SubItem?.length && <DownLtLogoBlue />}
    </div>
  );
});

interface FilteredMenuItemsProps {
  onMenuItemClick: (pageValue: number) => void;
  showMenuItem: boolean;
  isSponsoredCertificates?: boolean;
  associatedPrograms: AssociatedProgramInterface[];
  closeMenuHandler?: (href:string) => void;
}

const MenuItems: React.FC<FilteredMenuItemsProps> = React.memo(
  ({
    onMenuItemClick,
    showMenuItem,
    isSponsoredCertificates,
    associatedPrograms,
    closeMenuHandler
  }) => {
    const filteredMenuItems = useMemo(() => {
      return menuItemData
        .map((item, index) => (
          <MenuItemComponent
            key={index}
            item={item}
            onClick={() => onMenuItemClick(1)}
            closeMenuHandler={closeMenuHandler}
          />
        ));
    }, [onMenuItemClick]);

    return (
      <div
        className={`${styles.menuItemWrapper} ${
          showMenuItem ? styles.open : ""
        }`}
      >
        <div>{filteredMenuItems}</div>
        <MenuCTA
          isSponsoredCertificates={isSponsoredCertificates}
          associatedPrograms={associatedPrograms}
        />
      </div>
    );
  }
);

export default MenuItems;
